(function (Drupal) {
  Drupal.behaviors.klima = {
    postCardImagesEqualizer: function() {
      const winWidth = window.innerWidth;

      const sections = document.querySelectorAll(".article-list,.p-columns--6-6");
      sections.forEach((e) => {

        let currTop = -1;
        let rows = [];
        // const images = e.querySelectorAll(".img-fluid");
        const cols = e.querySelectorAll("div.col,.col-md-6,.col-lg-6");
        // cl(cols);
        if(cols.length > 0){
          cols.forEach(e => {
            const rect = e.getBoundingClientRect();
            const imgHeight = rect.height;
            if(currTop !== rect.top){
              currTop = rect.top;
              rows.push([]);
            }
            rows[rows.length - 1].push(e);
          })
        }
        if(rows.length > 0){
          rows.forEach( row => {
            let max = 0;
            row.forEach( e => {
              const img = e.querySelector("picture img");
              if(img) {
                const imgHeight = img.getBoundingClientRect().height;
                max = (imgHeight > max ? imgHeight : max);
              }
            })
            row.forEach( e => {
              const picture = e.querySelector("picture") || e.querySelector('.kf-news__image');
              if(picture) {
                picture.style.height = max + "px";
              }
            })
          })
        }
      });

    },
    postCardImagesEqualizerRow : function (){
      const row= [];
      const currCol = this.closest("div.col,.col-md-6,.col-lg-6");
      row.push(this);
      const currTop = currCol.getBoundingClientRect().top;
      let ele = currCol;
      let equal = false;
      do {
        equal = ele.previousElementSibling && ele.previousElementSibling.getBoundingClientRect().top === currTop
        if(equal){
          ele = ele.previousElementSibling;
          row.push(ele.querySelector("picture img")  || ele.querySelector('.kf-news__image'));
        }
      }while (equal);
      ele = currCol;
      do {
        equal = ele.nextElementSibling && ele.nextElementSibling.getBoundingClientRect().top === currTop
        if(equal){
          ele = ele.nextElementSibling;
          row.push(ele.querySelector("picture img")  || ele.querySelector('.kf-news__image'));
        }
      }while (equal);

      let max = 0;
      row.forEach( e => {
        if(e) {
          const imgHeight = e.getBoundingClientRect().height;
          max = (imgHeight > max ? imgHeight : max);
        }
      })
      row.forEach( e => {
        if(e){
          (e.closest("picture") || e).style.height = max + "px";
        }
      })


    },
    attach: function (context, settings) {
      once('init_post_card_image_equalizer', '.article-list,.p-columns--6-6').forEach(function (el) {
        window.addEventListener("resize", Drupal.behaviors.klima.postCardImagesEqualizer);
        //document.querySelectorAll(".card-img-top").forEach((img) => {
        Drupal.behaviors.klima.postCardImagesEqualizer();
      });

      document.querySelectorAll(".kf-news picture img:not([data-load-event])").forEach((img) => {
        img.addEventListener("load", Drupal.behaviors.klima.postCardImagesEqualizerRow);
        img.setAttribute("data-load-event", true);
      })

    },
  }
})(Drupal);


(function (Drupal) {
  Drupal.behaviors.klimaInit = {
    attach: function (context, settings) {

      if (window.location.hash) {
        once('init_hash_opened', window.location.hash).forEach(function (el) {
          if (el.children.length) {
            el.children[0].classList.remove('collapsed');
            el.nextElementSibling.classList.add('show');
          }
        });
      }
    },
    copyText: function(id) {

      const clip = window.location.origin + window.location.pathname + '#' + id;

      // Copy the text inside the text field
      navigator.clipboard.writeText(clip);

      // Alert the copied text
      alert("Link kopiert.");
    }
  }
})(Drupal);

(function ($, Drupal) {
  Drupal.behaviors.autofocusSearchInput = {
    attach: function () {
      $('.toggle-searchform').click(function(){
        $('input').focus();
      });
    }
  };

})(jQuery, Drupal);

(function (Drupal) {
  Drupal.behaviors.klimaMenuInit = {
    attach: function (context, settings) {
      const TopMenus = document.querySelectorAll("ul.navbar-nav > li.nav-item.dropdown");
      TopMenus.forEach( e => {
        e.addEventListener('click', (ev) => {
          try{
            const a = ev.target.querySelector("a");
            if(location.href !== a.href) {
              location.href = a.href;
            }
          } catch (e) {
            cl(e);
          }
        })
      })
    }
  }
})(Drupal);


// // init card images equalizer when resize window
// (function (Drupal) {
//   Drupal.behaviors.klimaInitImageEqualizer = {
//     attach: function initPostCardImagesEqualizer(){
//       // once('init_post_card_image_equalizer', 'body').forEach(function (el) {
//         window.addEventListener("resize", postCardImagesEqualizer);
//         document.querySelectorAll(".card-img-top").forEach((img) => {
//           img.addEventListener("load", postCardImagesEqualizer);
//         })
//         postCardImagesEqualizer();
//       // });
//     }
//   }
// })(Drupal);
//
// // card images equalizer
// (function (Drupal) {
//   Drupal.behaviors.klimaImageEqualizer = {
//     attach: function postCardImagesEqualizer(){
//       once('post_card_image_equalizer', 'body').forEach(function (el) {
//         var winWidth = window.innerWidth;
//         if(winWidth >= 768) {
//           var sections = document.querySelectorAll(".kf-news");
//           sections.forEach((e) => {
//             var images = e.querySelectorAll(".card-img-link");
//             if (images.length > 0) {
//               var max = 0;
//               images.forEach((con) => {
//                 var img = con.querySelector("img");
//                 var bounds = img.getBoundingClientRect();
//                 max = Math.max(bounds.height, max);
//               });
//               images.forEach((con) => {
//                 con.style.height = max + "px";
//               })
//             }
//           })
//         }else{
//           var images = document.querySelectorAll(".kf-news .card-img-link");
//           images.forEach((img) => {
//             img.style.height = null;
//           })
//         }
//       });
//     }
//   }
// })(Drupal);

function cl(msg){
  console.log(msg);
}
